<template>
  <router-view />
</template>

<script>
// import { mapGetters } from 'vuex';

export default {
};
</script>
